import { ReactElement } from 'react'
import { Container, TimelineMonth, TimelineSection } from './styles'

import {
  FaPencilAlt,
  FaTasks,
  FaThermometerHalf,
  FaBuilding,
  FaCogs
} from 'react-icons/fa'

const timeline = {
  initialYear: 2003,
  events: [
    {
      year: 2003,
      doings: [
        {
          title: 'Nascimento',
          description: 'Eu nasci.',
          tag: 'vida',
          author: 'Carlos',
          date: '02/14/2003'
        }
      ]
    },
    {
      year: 2007,
      doings: [
        {
          title: 'Primeiro Computador',
          description:
            'Ganhei meu primeiro computador, era um de tubo, comprado pelo meu pai, nas casas Bahia.',
          tag: 'tecnologia',
          author: 'Carlos',
          date: '02/14/2007'
        }
      ]
    },
    {
      year: 2011,
      doings: [
        {
          title: 'Mudança',
          description:
            'Sai de São Paulo, capital e fui morar no interior, em uma cidade chamada Cajamar.',
          tag: 'vida',
          author: 'Carlos',
          date: '02/10/2011'
        }
      ]
    },
    {
      year: 2017,
      doings: [
        {
          title: '1º Curso',
          description:
            'Inicio o meu primeiro curso, que é de informática básica. Aprendo o pacote Office.',
          tag: 'curso',
          author: 'Carlos',
          date: '02/14/2017'
        },
        {
          title: 'Ensino Fundamental',
          description: 'Finalizo o 9º ano do ensino fundamental.',
          tag: 'escola',
          author: 'Carlos',
          date: '12/13/2017'
        }
      ]
    },
    {
      year: 2018,
      doings: [
        {
          title: 'Etec',
          description:
            'Fiz o vestibular para entrar a Etec, no Ensino Médio Integrado ao Técnico de Informática.',
          tag: 'escola',
          author: 'Carlos',
          date: '01/21/2018'
        },
        {
          title: 'Etec',
          description: 'Primeiro dia letivo na instituição.',
          tag: 'escola',
          author: 'Carlos',
          date: '02/15/2018'
        },
        {
          title: 'LP',
          description: 'Meu primeiro contado com lógica de programação.',
          tag: 'escola',
          author: 'Carlos',
          date: '02/25/2018'
        },
        {
          title: 'Linguagem de Programação',
          description:
            'Meu primeiro contado com uma linguagem de programação, no caso C++.',
          tag: 'escola',
          author: 'Carlos',
          date: '02/25/2018'
        },
        {
          title: 'VBA',
          description:
            'Meu primeiro contado com VBA(Visual Basic for Applications).',
          tag: 'tecnologia',
          author: 'Carlos',
          date: '08/01/2018'
        },
        {
          title: 'Primeira Aplicação',
          description:
            'Minha primeira aplicação completa, era um Software De Gestão De Empresa, feito no excel, com VBA e macros para automação, com gerenciamento de estoque, gerador de boletos, etc...',
          tag: 'tecnologia',
          author: 'Carlos',
          date: '08/01/2018'
        }
      ]
    },
    {
      year: 2019,
      doings: [
        // {
        //   title: 'Etec',
        //   description: 'Primeiro contado com HTML e CSS.',
        //   tag: 'tecnologias',
        //   author: 'Carlos',
        //   date: '01/02/2019'
        // },
        // {
        //   title: 'Etec',
        //   description: 'Primeiro dia letivo na instituição.',
        //   tag: 'escola',
        //   author: 'Carlos',
        //   date: '02/15/2018'
        // }
      ]
    }
  ]
}
function Timeline(): ReactElement {
  return (
    <Container>
      <TimelineMonth className="timeline-month">
        {/* August, 2018 */}
        {timeline.initialYear}
        <span>{timeline.events.length} Entries</span>
      </TimelineMonth>

      <div className="TimelineContent">
        {timeline.events.map(event => (
          <TimelineSection key={event.year}>
            <div className="timeline-date">{event.year}</div>

            <div className="row">
              {event.doings.map(({ title, tag, description, date, author }) => (
                <div key={`${event.year}-${title}-${date}`} className="col">
                  <div className="timeline-box">
                    <div className="box-title">
                      <FaPencilAlt size={14} /> {title}
                    </div>
                    <div className="box-content">
                      <a className="tag">{tag}</a>
                      <div className="box-item">{description}</div>
                      <div className="box-item">
                        <strong>data:</strong>{' '}
                        {new Date(date).toLocaleDateString('pt-BR')}
                      </div>
                    </div>
                    <div className="box-footer">-{author}</div>
                  </div>
                </div>
              ))}
            </div>
          </TimelineSection>
        ))}

        {/* <TimelineSection>
          <div className="timeline-date">23, Thursday</div>
          <div className="row">
            <div className="col">
              <div className="timeline-box">
                <div className="box-title">
                  <FaTasks size={14} /> Job To Do Completed
                </div>
                <div className="box-content">
                  <a className="tag">Details</a>
                  <div className="box-item">
                    <strong>Employee</strong>: Sam
                  </div>
                  <div className="box-item">
                    <strong>Employee Response</strong>: Lorem ipsum dolor sit
                    amet, consectetur adipiscing elit. Nullam nisi viverra quis
                    felis sit amet, lacinia feugiat odio. Aliquam sed orci
                    elementum, volutpat dolor eget, venenatis nunc
                  </div>
                </div>
                <div className="box-footer">- Carol</div>
              </div>
              <div className="col">
                <div className="timeline-box">
                  <div className="box-title">
                    <FaCogs size={14} /> Equipment Entry
                  </div>
                  <div className="box-content">
                    <a className="tag">Details</a>
                    <div className="box-item">
                      <strong>ID</strong>: TW-3232
                    </div>
                    <div className="box-item">
                      <strong>Name</strong>: HEPA 600
                    </div>
                    <div className="box-item">
                      <strong>Date In</strong>: 08/22/2018
                    </div>
                  </div>
                  <div className="box-footer">- Jones</div>
                </div>
              </div>
            </div>
          </div>
        </TimelineSection> */}
      </div>
    </Container>
  )
}

export default Timeline
